import { useQueries } from "@tanstack/react-query";

import {
  LeafUsersDocument,
  useLeafUsersQuery,
  type LeafUsersQuery,
  type LeafUsersQueryVariables,
} from "@/graphql/generated";
import { fetcher } from "@/graphql/fetcher";

export function useFieldUsers(path: string | null) {
  const { data, isLoading, isError, refetch } = useLeafUsersQuery(
    { path: path ?? "" },
    { enabled: Boolean(path), staleTime: 60_000 },
  );
  return {
    users: data?.leafUsers ?? [],
    loading: Boolean(path) && isLoading,
    failed: isError,
    retry: () => void refetch(),
  };
}

export function useFieldUsersByPath(paths: string[]) {
  const results = useQueries({
    queries: paths.map((path) => ({
      queryKey: useLeafUsersQuery.getKey({ path }),
      queryFn: fetcher<LeafUsersQuery, LeafUsersQueryVariables>(
        LeafUsersDocument,
        { path },
      ),
      staleTime: 60_000,
    })),
  });
  return Object.fromEntries(
    paths.flatMap((path, i) => {
      const data = results[i].data;
      return data ? [[path, data.leafUsers]] : [];
    }),
  );
}
